// Session token storage (localStorage, every access wrapped: storage can be blocked or throw in private modes).
const KEY = 'xm.token';
let memory: string | null = null;

export function getToken(): string | null {
  try { return localStorage.getItem(KEY) ?? memory; } catch { return memory; }
}
export function setToken(token: string | null): void {
  memory = token;
  try {
    if (token) localStorage.setItem(KEY, token);
    else localStorage.removeItem(KEY);
  } catch { /* keep it in memory only */ }
}

/** Tiny safe wrappers for other modules' storage needs. */
export const safeStorage = {
  get(store: 'local' | 'session', key: string): string | null {
    try { return (store === 'local' ? localStorage : sessionStorage).getItem(key); } catch { return null; }
  },
  set(store: 'local' | 'session', key: string, value: string | null): void {
    try {
      const s = store === 'local' ? localStorage : sessionStorage;
      if (value == null) s.removeItem(key); else s.setItem(key, value);
    } catch { /* ignore */ }
  },
};
